<template>
    <div>
        <div class="row">
            <!-- start: pagetitle by afrin -->
            <div class="col-md-10 col-sm-12">
                <h4 class="atlhr-dashboard-title mt-10">Bulk Investment Approval<span><a
                            v-bind:href="$api_url + '/company/dashboard'">Dashboard</a> / Bulk Investment Approval</span>
                </h4>
            </div>
            <!-- end: pagetitle by afrin -->
            <div v-if="is_investment_enabled" class="col-sm-12">
                <div class="row mb-3 align-items-end">

                    <div class="col-md-4">
                        <b-form-group label="Select Fiscal Year" label-for="fiscal-year"
                            class="mb-0 d-block required-field">
                            <b-form-select id="fiscal-year" name="fiscal_year" v-model="fiscal_year"
                                :options="payrunyears" :state="validateState('fiscal_year')"
                                v-validate="{ required: true }" aria-describedby="fiscal-year-feedback"
                                data-vv-as="Fiscal year" class="custom-select"></b-form-select>
                            <b-form-invalid-feedback id="fiscal-year-feedback">{{ veeErrors.first('fiscal_year') }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <div class="col-md-8">
                        <a :href="$api_url + '/employee'"
                            class="btn btn-primary rounded p-2 pr-4 pl-4 float-right"><span><b-icon icon="reply"
                                    rotate="0" flip-h="" class="mr-2" scale="2"></b-icon></span><span>Back to
                                List</span></a>
                    </div>
                </div>
                <!-- added pageurl by afrin -->
                <common-list :email_class='this.emailing_class' :employee_draft=1 :pageurl="$api_url"
                    :checkbox="checkbox" :is_action="is_action" :key="list_key" :appended_column="appended_column"
                    :company_options="company_options" :employees="employees" :default_column="default_column"
                    :primary_key="primary_key" :switch_view="0" :all_employee="all_employee" edit_icon="yes"
                    hide_fields="yes"
                    v-on:childToParent="listReturn">
                    <!-- hide_fields is added by Afrin -->
                    <template v-slot:bulk-action>
                        <div class="d-inline-block mr-2" style="vertical-align: top;">
                            <span v-if="selected.length > 0" class="mr-2 font-weight-bold" style="line-height: 38px;">{{
                                selected.length }}
                                selected</span>
                            <b-dropdown text="Bulk Action" variant="primary" class="trz-custom-dropdown mb-1"
                                :disabled="selected.length == 0">
                                <b-dropdown-item @click="bulkAction('approve')">Approve Selected</b-dropdown-item>
                                <b-dropdown-item @click="bulkAction('delete')" variant="danger">Delete
                                    Selected</b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </template>
                </common-list>
            </div>
            <div v-else class="col-md-12 col-sm-12 mt-5">
                <p>You do not have the required permissions to access this page. Please contact your administrator if you believe you should have access.</p>
            </div>
        </div>
    </div>
</template>
<script>

export default {

    mounted() {
    },
    props: ['flg', 'pageurl'], //  added pageurl by afrin 
    data() {

        return {

            /**Child Component property data */
            emailing_class: '',
            checkbox: 1,
            modules: [],
            is_action: 0,
            list_key: 0,
            employees: [],
            default_column: ['name', 'employee_code', 'email', 'jobposition', 'department', 'fiscal_year'],
            primary_key: 'id',
            appended_column: [{ text: 'Type of Investment', value: 'type_name' }, { text: 'Investment Amount', value: 'amount' }, { text: 'Last Activity', value: 'last_activity' }, { text: 'Status', value: 'status_label' }],
            all_employee: 'no',
            /***Child Component property data */

            flag: this.flg,
            ce: false,
            empfile: null,
            has_file: false,
            errormsg: [],
            showoverlay: true,
            show_employee_list: false,
            people: 0,
            blankmsg: 'Fetching data..',
            upload_url: '',
            process_url: '',
            successmsg: false,
            warningmsg: false,
            dangermsg: false,
            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },
            search: '',
            length: 10,
            selected: [],
            fiscal_year: this.getCurrentFinancialYear(),
            payrunyears: [],
            decimal_setting: '',
            company_options: [],
            search_group: { name: '', email: '', phone: '' },
            search_by_id: { department_id: 0, jobposition_id: 0, branch_id: 0 },

            depertments: [],
            jobtypes: [],
            branches: [],
            // approver settings
            is_investment_enabled: false,
            // approver settings
        }
    },
    methods: {
        getpayrunyears: function () {
            axios.get(this.$api_url + '/get/fiscalyear/list').then(function (response) {
                this.payrunyears = response.data;

            }.bind(this));
        },

        setUrls: function () {
            this.flag = parseInt(this.flag);

            if (this.flag == 1) {

                this.upload_url = this.$api_url + "/employee/import-for-update";
                this.process_url = this.$api_url + '/employee/import-for-update/processdata';

            }
            else if (this.flag == 2) {

                this.upload_url = this.$api_url + "/employee/import-employee-email-phone";
                this.process_url = this.$api_url + '/employee/import-employee-email-phone/processdata';

            }
            else {

                this.upload_url = this.$api_url + "/employee/import";
                this.process_url = this.$api_url + '/employee/import/processdata';
            }

        },
        exportUpdate: function (flg = 0) {
            if (!this.checkNet()) return false;


            let currentObj = this;
            this.$bvToast.toast('It might take a while', {
                title: `Info`,
                variant: 'info',
                solid: true
            });
            this.showoverlay = true;
            let formData = new FormData();
            formData.append('employee_ids', 'all');
            formData.append('flg', flg);
            formData.append('forupdate', 1);

            axios.post(this.$api_url + '/employee/export-for-update', formData)
                .then(function (response) {
                    this.showoverlay = false;
                    //window.open(response.data);
                    var fileURL = response.data;

                    this.downloadFileContent(fileURL);

                }.bind(this))
                .catch(function (error) {
                    currentObj.showoverlay = false;
                    currentObj.serverError(error);
                });
        },

        exportEmailPhone: function (flg = 0) {
            if (!this.checkNet()) return false;


            let currentObj = this;
            this.$bvToast.toast('It might take a while', {
                title: `Info`,
                variant: 'info',
                solid: true
            });
            this.showoverlay = true;
            let formData = new FormData();
            formData.append('employee_ids', 'all');
            formData.append('flg', 6);
            formData.append('forupdate', 1);

            if (flg == 1) {
                formData.append('template_filter', 'active');
            }
            else if (flg == 2) {
                formData.append('template_filter', 'inactive');
            }

            axios.post(this.$api_url + '/employee/export-for-update', formData)
                .then(function (response) {
                    this.showoverlay = false;
                    //window.open(response.data);
                    var fileURL = response.data;

                    this.downloadFileContent(fileURL);

                }.bind(this))
                .catch(function (error) {
                    currentObj.showoverlay = false;
                    currentObj.serverError(error);
                });
        },
        exportUpdateWithStatus: function (flg = 0) {
            if (!this.checkNet()) return false;


            let currentObj = this;
            this.$bvToast.toast('It might take a while', {
                title: `Info`,
                variant: 'info',
                solid: true
            });
            this.showoverlay = true;
            let formData = new FormData();
            formData.append('employee_ids', 'all');

            if (flg == 1) {
                formData.append('template_filter', 'active');
            }
            else if (flg == 2) {
                formData.append('template_filter', 'inactive');
            }

            formData.append('forupdate', 1);

            axios.post(this.$api_url + '/employee/export-for-update', formData)
                .then(function (response) {
                    this.showoverlay = false;
                    //window.open(response.data);
                    var fileURL = response.data;

                    this.downloadFileContent(fileURL);

                }.bind(this))
                .catch(function (error) {
                    currentObj.showoverlay = false;
                    currentObj.serverError(error);
                });
        },
        uploadFile: function (event) {
            if (!this.checkNet()) return false;
            this.showoverlay = true;
            this.show_employee_list = false;
            this.errormsg = [];
            // this function upload the logo
            this.empfile = event.target.files[0];

            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            const data = new FormData();
            data.append('empfile', this.empfile);

            axios.post(this.upload_url, data, config).
                then(function (response) {

                    this.has_file = true;

                    this.$bvToast.toast('Processing the data feed file.', {
                        title: `Job on progress`,
                        variant: 'info',
                        solid: true
                    });

                    this.processFileData();

                }.bind(this)).
                catch(function (error) {
                    //alert(error.response.data.errors);
                });
        },
        processFileData: function () {
            if (!this.checkNet()) return false;
            this.showoverlay = true;
            let currentObj = this;
            this.errormsg = [];
            axios.get(this.process_url)
                .then(function (response) {

                    if (response.data.status) {
                        this.$bvToast.toast('Data feed file successfully imported', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });

                        this.employees = response.data.employees;
                        if (this.employees.length == 0)
                            this.blankmsg = "Nothing found.";
                        else
                            this.people = this.employees.length;

                        this.show_employee_list = true;

                        setTimeout("location.href = '" + this.$api_url + "/employee';", 1500);
                    }
                    else {
                        this.errormsg = response.data.errors;
                    }

                    this.showoverlay = false;

                }.bind(this)).catch(function (error) {


                    //currentObj.serverError(error);
                    currentObj.showoverlay = false;
                    currentObj.$bvToast.toast('Please correct the data and try again. There might be any non well formed numeric value encountered.', {
                        title: `Data Template Error`,
                        variant: 'danger',
                        solid: true
                    });

                });;
        },



        resetPagination() {
            this.pagination.currentPage = 1;
            this.pagination.prevPage = '';
            this.pagination.nextPage = '';
        },
        paginate(array, length, pageNumber) {
            let l = parseInt(array.length);
            let m = parseInt(length);
            this.pagination.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
            this.pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
            this.pagination.prevPage = pageNumber > 1 ? pageNumber : '';
            this.pagination.nextPage = array.length > this.pagination.to ? pageNumber + 1 : '';

            if (l > 0) {
                this.pagination.pages = Math.ceil(l / m);
            }
            this.people = l;
            return array.slice((pageNumber - 1) * length, pageNumber * length);
        },
        editEmployee: function (x, i) {
            if (!this.checkNet()) return false;

            let formData = new FormData();
            formData.append('employee_id', x);
            axios.post(this.$api_url + '/employee/setemployee', formData)
                .then(function (response) {
                    if (i > 0)
                        window.location.href = this.$api_url + '/employee/info?#=' + i;
                    else
                        window.location.href = this.$api_url + '/employee/info';

                }.bind(this))
                .catch(function (error) {
                    currentObj.errormsg = error.response.data.errors;
                });

        },
        listReturn: function (data) {
            if (data.selected != null && data.selected.length > 0) {
                this.selected = data.selected;
            }
            else {
                this.selected = [];
                if (data.id > 0) {
                    if (data.action_id == 'approve') {
                        this.approveInvestment(data.id, 1);
                    } else if (data.action_id == 'edit') {
                        this.editInvestment(data.id);
                    } else if (data.action_id == 'delete') {
                        this.deleteInvestment(data.id);
                    } else {
                        if (data.employee_id > 0)
                            this.editEmployee(data.employee_id, 0);
                    }
                }
            }
        },
        getInvestments: function () {
            if (this.fiscal_year == '') return;
            axios.get(this.$api_url + '/employee/pendinginvestment', {
                params: {
                    fiscal_year: this.fiscal_year,
                    ajax: 1
                }
            }).then(function (response) {
                this.employees = response.data.data;

                this.employees.forEach(e => {
                    e.amount = this.moneyFormat(e.amount);
                });

                this.company_options = response.data.options;
                this.selected = [];
                this.list_key++;
            }.bind(this));
        },
        // Afrin: changed 7-9 start
        bulkAction: function (action) {
            if (this.selected.length == 0) return;
            if (action == 'delete') {
                let hasApproved = false;
                for (let i = 0; i < this.selected.length; i++) {
                    let selectedId = this.selected[i];
                    let record = this.employees.find(e => e.id == selectedId);
                    if (record && record.status == 1) {
                        hasApproved = true;
                        break;
                    }
                }
                if (hasApproved) {
                    this.$bvToast.toast('Approved Investment cannot be deleted. Please unapprove first!', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                    return;
                }
            }
            if (action == 'approve') {
                let hasApproved = false;
                for (let i = 0; i < this.selected.length; i++) {
                    let selectedId = this.selected[i];
                    let record = this.employees.find(e => e.id == selectedId);
                    if (record && record.status == 1) {
                        hasApproved = true;
                        break;
                    }
                }
                if (hasApproved) {
                    this.$bvToast.toast('Approved Investment cannot be approved.', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                    return;
                }
            }
            var message = action == 'approve' ? 'Please confirm that you want to Approve the selected investments' : 'Please confirm that you want to Delete the selected investments';
            this.$bvModal.msgBoxConfirm(message, {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
            .then(value => {
                if (value) {
                    this.showoverlay = true;
                    axios.post(this.$api_url + '/employee/pendinginvestment', {
                        ids: this.selected,
                        action: action,
                        status: action == 'approve' ? 1 : 0
                    }).then(function (response) {
                        this.showoverlay = false;
                        if (response.data.status) {
                            this.$bvToast.toast(response.data.meg, {
                                title: 'Success',
                                variant: 'success',
                                solid: true
                            });
                            this.getInvestments();
                        } else {
                            this.$bvToast.toast(response.data.meg, {
                                title: 'Error',
                                variant: 'danger',
                                solid: true
                            });
                        }
                    }.bind(this)).catch(function (error) {
                        this.showoverlay = false;
                        this.$bvToast.toast('Error processing request', {
                            title: 'Error',
                            variant: 'danger',
                            solid: true
                        });
                    }.bind(this));
                }
            });
        },
        // Afrin: changed 7-9 end
        removeDecimal: function (x) {
            return x.split('.')[0];
        },
        moneyFormat: function (amount) {
            if (typeof amount === 'string') {
                amount = amount.replace(/,/g, '');
            }
            var money = Number(amount);
            money = money.toLocaleString();
            if (this.decimal_setting == 'yes' || this.decimal_setting == '')
                if (money.indexOf(".") < 0)
                    money = money + '.00';
            return money;
        },
        formatMe: function (x) {
            return x;
        },
        approveInvestment: function (id, status) {
            if (!confirm('Are you sure?')) return;
            axios.post(this.$api_url + '/employee/pendinginvestment', {
                id: id,
                status: status,
                action: 'approve'
            }).then(function (response) {
                if (response.data.status) {
                    this.$bvToast.toast(response.data.meg, {
                        title: 'Success',
                        variant: 'success',
                        solid: true
                    });
                    this.getInvestments();
                }
            }.bind(this));
        },
        editInvestment: function (id) {
            this.$bvToast.toast('Edit functionality depends on specific employee session. Redirecting...', { title: 'Info', variant: 'info' });
        },
        deleteInvestment: function (id) {
            if (!confirm('Are you sure to delete?')) return;
            axios.post(this.$api_url + '/employee/pendinginvestment', {
                id: id,
                action: 'delete'
            }).then(function (response) {
                if (response.data.status) {
                    this.$bvToast.toast(response.data.meg, {
                        title: 'Success',
                        variant: 'success',
                        solid: true
                    });
                    this.getInvestments();
                }
            }.bind(this));
        },

        // approver settings
        get_tax_reducers_settings: function(){
            axios.get('/get/taxreducers/settings').then(function (response) {
            if(response.data.investments && response.data.investments == 1){
                this.is_investment_enabled = true;
            }else{
                this.is_investment_enabled = false;
            }

            }.bind(this));
        },
        // approver settings


    },
    created: function () {
        this.setUrls();
        this.getpayrunyears();
        this.get_tax_reducers_settings(); // approver settings

        axios.get(this.$api_url + '/decimal-settings').then(function (response) {
            this.decimal_setting = response.data;
            this.getInvestments();
        }.bind(this));

        Fire.$on('reloadUsers', () => { this.processFileData() })
    },
    watch: {
        fiscal_year: function (val) {
            this.getInvestments();
        }
    },

    computed:
    {
        filteredData() {
            let filtered_list = this.employees;
            if (this.search) {
                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1; }) });

                if (filtered_list.length == 0)
                    this.blankmsg = "Nothing found.";
            }

            this.people = filtered_list.length;

            return filtered_list;
        },
        paginatedData() {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        }
    }
}
</script>
